import { useMutation } from '@tanstack/react-query';

import { recognitionServices } from '@hero/services';

export const useRecognitionReachOutSupport = ({ options = {} } = {}) =>
  useMutation(
    ({ params, body }) => recognitionServices.recognitionReachOutSupport(params, body),
    options
  );
